import { render, staticRenderFns } from "./accountreviw.vue?vue&type=template&id=59ef607e&scoped=true&"
import script from "./accountreviw.vue?vue&type=script&lang=js&"
export * from "./accountreviw.vue?vue&type=script&lang=js&"
import style0 from "./accountreviw.vue?vue&type=style&index=0&id=59ef607e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ef607e",
  null
  
)

export default component.exports